import * as React from "react";

import styled from "@emotion/styled";
import { breakpoints } from "../styles/breakpoints";
import { PricingLink } from "./pricing-link";
import { Inc5000 } from "./inc-5000";

const StyledHero = styled.header`
  background: var(--off-white);

  .wrapper {
    position: relative;
    display: flex;
    text-align: center;
    height: 100vh;
    min-height: 620px;
    max-height: 80rem;
    overflow: hidden;

    @media(max-width: ${breakpoints.lg}) {
      min-height: 560px;
    }

    @media(max-width: 450px) {
      min-height: 740px;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    min-height: 600px;
  }

  .bg {
    position: absolute;
    max-width: 380px;
    max-height: 320px;
    width: 30vw;
    bottom: 0;
    z-index: 0;

    &--left {
      left: 7vw;
    }

    &--right {
      right: 7vw;
    }

    @media(max-width: ${breakpoints["2xl"]}) {
      max-height: 220px;
      max-width: 300px;
    }

    @media(max-width: ${breakpoints.lg}) {
      max-height: 180px;
      max-width: 260px;

      &--left {
        left: 3vw;
      }

      &--right {
        right: 3vw;
      }
    }

    @media(max-width: ${breakpoints.sm}) {
      max-height: 120px;
    }

    @media (max-width: ${breakpoints.xs}) {
      max-height: 100px;
      transform: scale(1.1) translateY(-5%);

      &--left {
        left: 5vw;
      }

      &--right {
        right: 5vw;
      }
    }

    &-home {
      max-width: 600px;
      max-height: 600px;

      &--left {
        width: 32vw;
        left: 0;
      }

      &--right {
        right: 0;
        width: 35vw;
      }
    }
  }

  .text-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 99.9rem;
    margin: calc(var(--large) * 2.5) auto 0;

    @media(max-width: ${breakpoints.sm}) {
      margin-top: calc(var(--large) * 2);
    }
  }

  p {
    max-width: 56rem;
    margin: var(--xx-small) auto var(--x-small);
  }
`;

interface HeroProps {
  title: string;
  text: string;
  bgLeft: string;
  bgRight: string;
  isRenderedOnHome?: boolean;
  bgStylesCommon?: React.CSSProperties;
}

export const Hero = ({
  title,
  text,
  bgLeft,
  bgRight,
  isRenderedOnHome,
  bgStylesCommon
}: HeroProps) => (
  <StyledHero>
    <div
      className="wrapper"
      style={
        !isRenderedOnHome
          ? {
              maxWidth: "170rem",
              margin: "auto",
              width: "100%",
            }
          : {}
      }
    >
      <img
        className={`bg  ${
          isRenderedOnHome ? "bg-home bg-home--left" : "bg--left"
        }`}
        style={bgStylesCommon}
        src={bgLeft}
        aria-hidden="true"
      />
      <div className="row">
        <div className="text-box">
          <h1 className="h1">{title}</h1>
          <p className="text-large">{text}</p>
          <PricingLink to="/pricing" className="btn-brand">
            SEE PLANS & PRICING
          </PricingLink>
          <Inc5000 />
        </div>
      </div>
      <img
        className={`bg  ${
          isRenderedOnHome ? "bg-home bg-home--right" : "bg--right"
        }`}
        style={bgStylesCommon}
        src={bgRight}
        aria-hidden="true"
      />
    </div>
  </StyledHero>
);
